/* eslint-disable */
import { StyleSheet ,Dimensions} from 'react-native'
import { Fonts } from '../../Themes/'

export default StyleSheet.create({

  container: {
    flex: 1,

  },
  fake : {
    top: 0,right : 0,left : 0,
    position: `absolute`,
    width:Dimensions.get('window').width - 100,
    backgroundColor: 'transparent',
    padding: 10,
    borderRadius: 5,
    minHeight: 100
  },
  readerMore : {

     alignSelf: 'flex-end',

  },
  avatarContainerRow: {
    flexDirection: 'row',
    marginRight: 10,
    justifyContent: 'center',
    alignItems: 'center'
  },

  avatarContainer: {
    height: 100,
    width: 100,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center"
  },
  textDescriptionContainer: {
    flex: 1,
    backgroundColor: '#f8f8f8',
    padding: 10,
    borderRadius: 5,
    minHeight: 100

  },

  add: {
    width: 20,
    height: 20,

  },
  textDescription: {
    fontSize: 14,
    color: 'black'
  },
  avatarBorder: {
    paddingTop: 2,
    paddingLeft: 2,
    height: 80,
    width: 80,
  },
  avatar: {
    height: 80,
    width: 80,
    borderRadius: 40,
    borderColor: Fonts.style.color.baseRed,
    borderWidth: 2
  },
  avatarOnline: {
    height: 80,
    width: 80,
    borderRadius: 40,
    borderColor: Fonts.style.color.green,
    borderWidth: 2
  },
  avatarOffline: {
    height: 80,
    width: 80,
    borderRadius: 40,
    borderColor: Fonts.style.color.baseRed,
    borderWidth: 2
  },
  card: {
    marginHorizontal: 10,
    padding: 10,
    borderRadius: 3,
    borderColor: 'rgba(0,0,0,0.1)',
    borderWidth: 1,
    backgroundColor: '#fff',
  },
  cardText: {
    fontSize: 14,
  },
})
